module.exports = __webpack_public_path__ + "static/media/ap.f569ee4f.png";